import {store} from "../../redux/store/store";
import {logout} from "../../redux/slice/authSlice";

export const LOGIN_NOTICE_KEY = "loginNotice";

let isHandling = false;

export function isNetworkError(error) {
    return !error?.response;
}

export function handleServerUnavailable() {
    if (isHandling || !localStorage.getItem("accessToken")) {
        return false;
    }

    isHandling = true;
    sessionStorage.setItem(
        LOGIN_NOTICE_KEY,
        "서버에 연결할 수 없습니다. 확인 후 다시 로그인해 주세요."
    );
    localStorage.clear();
    store.dispatch(logout());
    window.location.replace("/login");
    return true;
}
